import { render } from "./strategy.vue?vue&type=template&id=41d10fec&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"

import "./strategy.vue?vue&type=style&index=0&id=41d10fec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41d10fec"

export default script